import { render, staticRenderFns } from "./UserMescanDataWaterDrop.vue?vue&type=template&id=62f70c97&scoped=true"
import script from "./UserMescanDataWaterDrop.vue?vue&type=script&lang=js"
export * from "./UserMescanDataWaterDrop.vue?vue&type=script&lang=js"
import style0 from "./UserMescanDataWaterDrop.vue?vue&type=style&index=0&id=62f70c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f70c97",
  null
  
)

export default component.exports